
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface CoachBasicInfoSectionProps {
  formData: {
    first_name: string;
    last_name: string;
    username: string;
    phone: string;
    bio: string;
  };
  onInputChange: (name: string, value: string) => void;
}

export const CoachBasicInfoSection: React.FC<CoachBasicInfoSectionProps> = ({
  formData,
  onInputChange
}) => {
  return (
    <Card className="bg-gray-700 border-gray-600">
      <CardHeader>
        <CardTitle className="text-white text-lg">Basic Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="first_name" className="text-gray-300">First Name *</Label>
            <Input
              id="first_name"
              value={formData.first_name}
              onChange={(e) => onInputChange('first_name', e.target.value)}
              className="bg-gray-600 border-gray-500 text-white"
              required
            />
          </div>
          <div>
            <Label htmlFor="last_name" className="text-gray-300">Last Name *</Label>
            <Input
              id="last_name"
              value={formData.last_name}
              onChange={(e) => onInputChange('last_name', e.target.value)}
              className="bg-gray-600 border-gray-500 text-white"
              required
            />
          </div>
          <div>
            <Label htmlFor="username" className="text-gray-300">Username *</Label>
            <Input
              id="username"
              value={formData.username}
              onChange={(e) => onInputChange('username', e.target.value)}
              className="bg-gray-600 border-gray-500 text-white"
              required
            />
          </div>
          <div>
            <Label htmlFor="phone" className="text-gray-300">Phone Number</Label>
            <Input
              id="phone"
              type="tel"
              value={formData.phone}
              onChange={(e) => onInputChange('phone', e.target.value)}
              className="bg-gray-600 border-gray-500 text-white"
            />
          </div>
        </div>
        <div>
          <Label htmlFor="bio" className="text-gray-300">Bio</Label>
          <Textarea
            id="bio"
            value={formData.bio}
            onChange={(e) => onInputChange('bio', e.target.value)}
            placeholder="Tell others about yourself as a coach..."
            className="bg-gray-600 border-gray-500 text-white placeholder-gray-400"
          />
        </div>
      </CardContent>
    </Card>
  );
};
